export default {
  // 获取微信jssdk配置_伍志长
  getWxJsConfig(params) {
    return app.http.ajax({
      method: 'get',
      url: '/mall-portal/common/getWxJsConfig',
      params,
    });
  },
};
